export const environment = {
  production: false,
  grafana: {
    url: 'https://faro-collector-prod-us-east-2.grafana.net/collect/71d8f1681047d40fa402333f53f29529',
    appName: 'Test Panorama',
    env: 'test',
  },
  aws: {
    // Feature flags proxy GitLab's Unleash API, mapping its `features` shape to
    // the `toggles` shape unleash-proxy-client expects. Shares the secure proxy's
    // API and conventions, but its route is deliberately unauthenticated: the
    // client starts at app bootstrap, before a Ping token exists, and it calls
    // with its own fetch so the ping-auth interceptor never sees it.
    featureFlagEndpoint: 'https://test-panorama.roche.com/api/v1/flags',
    featureFlagAppName: 'test',
    // Secure proxy (API Gateway → Lambda → Secrets Manager). Backend secrets
    // injected server-side; the SPA sends only the user's Ping bearer token.
    // Served same-origin under the SPA's own domain via CloudFront /api/v1/*
    // behaviors → API GW. Same origin = zero CORS. A viewer-request function
    // (api-v1-uri-rewrite) maps /api/v1/<svc>/… onto the gateway stage
    // /test/<svc>/…, because the gateway has no /api/v1 resources of its own.
    mulesoftEndpoint: 'https://test-panorama.roche.com/api/v1/mulesoft',
    fulfillmentEndpoint: 'https://test-panorama.roche.com/api/v1/fulfillment',
    sinequaEndpoint: 'https://test-panorama.roche.com/api/v1/sinequa',
    // Assistant streams SSE, which API Gateway cannot do (it buffers, and caps
    // the integration at 29s). So it is served from the SPA's own CloudFront
    // distribution under /api/v1/* → a Lambda Function URL (RESPONSE_STREAM)
    // fronted by OAC — same origin as the SPA. The OAC SigV4-signs the IAM
    // origin; the Ping bearer rides in X-Ping-Authorization (ping-auth.interceptor).
    assistantEndpoint: 'https://test-panorama.roche.com/api/v1/assistant',
  },
  gTag: 'G-1YM3S9JD1H',
  pingAuthInit: true,
  pingAuthMock: {},
  ping: {
    authority: 'https://wamua.roche.com',
    clientId: 'panorama-uat',
    redirectUrl: 'https://test-panorama.roche.com/',
    scope: 'openid profile email groups',
  },
  moderatorGroup: 'Panorama_Moderators-Tst',
};
